export interface DayBucket {
  day: string;
  sandbox: number;
  production: number;
}

/** Stacked daily bars: live on the bottom in the role colour, sandbox above in amber. */
export function ActivityBars({ days }: { days: DayBucket[] }) {
  const max = Math.max(1, ...days.map((d) => d.sandbox + d.production));
  const total = days.reduce((a, d) => a + d.sandbox + d.production, 0);
  return (
    <figure style={{ margin: 0 }}>
      <div className="bars" role="img" aria-label={`${total} transactions over ${days.length} days`}>
        {days.map((d) => (
          <div className="bar" key={d.day} title={`${d.day}: ${d.production} live, ${d.sandbox} sandbox`}>
            <div className="seg-p" style={{ height: `${(d.production / max) * 100}%` }} />
            <div className="seg-s" style={{ height: `${(d.sandbox / max) * 100}%` }} />
          </div>
        ))}
      </div>
      <div className="bars-axis" aria-hidden="true">
        {days.map((d, i) => (
          <span key={d.day}>{i % 2 === 0 || days.length <= 7 ? d.day.slice(8) : ""}</span>
        ))}
      </div>
      <figcaption className="legend" style={{ marginTop: 10 }}>
        <span><i style={{ background: "var(--role)" }} />Live</span>
        <span><i style={{ background: "var(--sandbox)", opacity: 0.75 }} />Sandbox</span>
        <span style={{ marginLeft: "auto" }}>Peak {max} per day</span>
      </figcaption>
    </figure>
  );
}
